import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'td-wb-consolidated-agreements-tooltip',
  templateUrl: './consolidated-agreements-tooltip.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class ConsolidatedAgreementsTooltipComponent {
  @Input('label') label: string;
}
